import { ref } from 'vue'
import { fetchSettingBuyforyou as fetchSettingBuyforyouApi } from '@/assets/ts/apiManagement'

export function useBuyforyou() {
	const buyforyouWarehouses = ref<string[]>([])

	/**
	 * Fetches the buyforyou warehouses to get warehouse Array.
	 */
	const fetchBuyforyouWarehouses = async () => {
		const result = await fetchSettingBuyforyouApi()
		buyforyouWarehouses.value = result.formattedBuyforyouWarehouses
	}

	return {
		buyforyouWarehouses,
		fetchBuyforyouWarehouses,
	}
}
